import { useMutation } from '@tanstack/react-query';
import type { UpdateCardRequestDto, UpdateCardResponseDto } from '../../model';
import { updateCard } from '../requests';

interface Options {
  onSuccess?: (data: UpdateCardResponseDto) => void;
  onError?: (error: Error) => void;
}

type UpdateCardVariables = {
  templateId: string;
  data: UpdateCardRequestDto;
};

export function useUpdateCard({ onSuccess, onError }: Options) {
  const mutation = useMutation<
    UpdateCardResponseDto,
    Error,
    UpdateCardVariables
  >({
    mutationFn: ({ templateId, data }) => updateCard(templateId, data),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
